import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/Home',
        name: 'Home',
        component: Home
    },
    {
        path: '/Practica1',
        name: 'Practica1',
        component: () =>
            import ( /* webpackChunkName: "practica1" */ '../views/Practica1.vue')
    },
    {
        path: '/Practica2',
        name: 'Practica2',
        component: () =>
            import ( /* webpackChunkName: "practica2" */ '../views/Practica2.vue')
    }
]

const router = new VueRouter({
    mode: "history",
    base: '/proyectoswd2425/',
    routes
})

export default router
